import { useContext } from 'react'
import { StepTreePathChain } from '../utils/stepPathChainManagement'
import { StepTreePathContext } from '../StepTreePathProvider'

export const useStepTreePath = () => {
  const parentPath = useContext(StepTreePathContext).path

  if (!parentPath) {
    return new StepTreePathChain().getPath()
  }

  return parentPath
}
